<div fxFlexFill *ngIf="user$ | async as user">
  <button mat-icon-button routerLink="/users">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h1>{{user.first_name + ' ' + user.last_name}}</h1>
  <app-user-form [user]="user$"></app-user-form>
</div>